import * as React from 'react';
import { MouseEvent } from 'react';
import { IDriveDocProps } from './types';
import { CARD_CLASS, CARD_CONTROL_CLASS } from '../../../../constants';
import { Util } from '../../../../../../../../util/util';
import './_DriveDoc.scss';
import { Button, Icon, Tooltip } from 'kui';
import { DRIVE_DOC_GOOGLE_THUMB_SIZE, MIME_TYPE_GOOGLE_APPS } from './constants';
import { DRIVE_DOC_TOOLTIP } from '../../../../wording';
import { EAuthUserPlatformType } from 'app/types/rest/IRestAuthUser';
import { msFileThumbnailStorage } from '../../../../../../../../helper/authorisation/microsoft/storage/msThumbnail';
import { THUMB_CARD_SIZE } from '../../../../../../../../const';
import {
    googleFileThumbnailStorage
} from '../../../../../../../../helper/authorisation/google/storage/googleThumbnail';
import { AnalyzeRender } from '../../../../../../helpers/memoizeHelper';
// @ts-ignore
const analyzeRender = window.Settings.development ? new AnalyzeRender(`DriveDoc`) : null;

export function DriveDoc({
    driveDoc,
    onDownload,
    onLinkClick,
}: IDriveDocProps) {
    if (!driveDoc) return null;

    if (analyzeRender) analyzeRender.call(driveDoc.id);

    const classFile = CARD_CLASS + '__drive-docs__file';
    const isPreviewType = Util.fileIsImage(driveDoc.mimeType) || Util.fileIsVideo(driveDoc.mimeType);

    const onClick = (
        e: MouseEvent
    ) => {
        e.stopPropagation();
        onDownload(driveDoc.driveId, driveDoc.fileId);
    };

    const onLoad = () => {
        setIsLoad(true)
    };

    const [isLoad, setIsLoad] = React.useState(null);
    let [thumbUrl, _setThumbUrl] = React.useState(null);
    const setThumbUrl = (url: any) => {
        thumbUrl = url;
        _setThumbUrl(url);
    }
    React.useEffect(() => {
        if (!isPreviewType) return;
        if (msFileThumbnailStorage.is()) {
            const thumbSize = `c${THUMB_CARD_SIZE}x${THUMB_CARD_SIZE}`;
            msFileThumbnailStorage.getThumbnail(driveDoc.driveId, driveDoc.fileId, thumbSize)
                .then(thumb => setThumbUrl(thumb.url));
        } else if (googleFileThumbnailStorage.is()) {
            googleFileThumbnailStorage.getThumbnail(driveDoc.fileId, DRIVE_DOC_GOOGLE_THUMB_SIZE)
                .then(thumb => setThumbUrl(thumb));
        }
    }, [driveDoc]);

    const tooltipImg = <img src={thumbUrl}/>

    const icon = driveDoc.iconUrl
        ? isPreviewType
            ? <Tooltip value={driveDoc.title} footer={tooltipImg}>
                <img
                    className={classFile + '_icon'}
                    src={thumbUrl}
                    onError={() => {
                        if (googleFileThumbnailStorage.is()) {
                            googleFileThumbnailStorage.reGetThumbnail(
                                driveDoc.fileId,
                                DRIVE_DOC_GOOGLE_THUMB_SIZE,
                                setThumbUrl,
                            );
                        }
                    }}
                    onLoad={onLoad}
                />
            </Tooltip>
            : <img className={classFile + '_icon'} src={driveDoc.iconUrl} onLoad={onLoad}/>
        : <Icon className={classFile + '_icon'} xlink={'attachment'} size={24}/>;

    const downloadUrl = Util.fileHasAvailableMimeType(driveDoc.mimeType)
        ? Util.createDownLoadLink(driveDoc.fileId)
        : null;

    const downloadButton = driveDoc.platformType === EAuthUserPlatformType.MICROSOFT
        ? null
        : {
            href: downloadUrl,
            target: '_blank',
        }

    return (
        <div className={classFile} key={driveDoc.fileId}>
            <a
                className={`
                    ${classFile}_link
                    ${isLoad ? classFile + '_link-loaded' : ''}
                    ${CARD_CONTROL_CLASS}
                `}
                href={driveDoc.url}
                target={'_blank'}
                onClick={(e) => onLinkClick(e, driveDoc.id)}
            >
                {icon}
                <span className={classFile + '_title'}>
                    {driveDoc.title}
                </span>
            </a>
            {
                !driveDoc.mimeType.includes(MIME_TYPE_GOOGLE_APPS) &&
                <Tooltip
                    isNoEvents
                    isNoWrap
                    value={DRIVE_DOC_TOOLTIP}
                >
                    <Button
                        className={classFile + '_download'}
                        {...downloadButton}
                        variant={'icon'}
                        onClick={onClick}
                    >
                        <Icon size={24} xlink={'cloud-upload'}/>
                    </Button>
                </Tooltip>
            }
        </div>
    );
}
